import { Chip, Stack } from '@mui/joy';
import { formatRating } from '../utils/rating';

export default function SurveyorStats({ employee, stats = employee?.surveyor_stats }) {
  if (!stats) return null;
  return <Stack direction="row" flexWrap="wrap" gap={0.5} alignItems="center" sx={{ alignSelf: 'flex-start', minWidth: 0, maxWidth: '100%', '& > *': { flex: '0 0 auto', alignSelf: 'center', minHeight: 20, maxHeight: 26 } }} aria-label="Статистика обмерщика">
    <Chip size="sm" variant="soft" color="warning">★ {formatRating(stats.rating)}</Chip>
    <Chip size="sm" variant="soft" color="neutral">Отзывы: {stats.reviews_count || 0}</Chip>
    <Chip size="sm" variant="soft" color="primary">Обмеры: {stats.completed_count || 0}</Chip>
  </Stack>;
}
